import { useLocation } from '@solidjs/router';
import { createEffect, Show } from 'solid-js';
import BreakpointIndicator from './BreakpointIndicator';
import ExportAuthLogsButton from './ExportAuthLogsButton';
import './DevToolbar.css';
import type { Component } from 'solid-js';

const DevToolbar: Component = () => {
  const location = useLocation();

  createEffect(() => {
    const _pathname = location.pathname;

    const toolbar = document.querySelector('[data-dev-toolbar]') as HTMLElement;
    if (toolbar) {
      toolbar.classList.add('dev-toolbar-reset');
      setTimeout(() => {
        toolbar.classList.remove('dev-toolbar-reset');
      }, 300);
    }
  });

  return (
    <Show when={import.meta.env.DEV}>
      <div data-dev-toolbar class="dev-toolbar group fixed left-1/2 z-50 hidden -translate-x-1/2 md:block">
        <div class="dev-toolbar-hotzone" />

        <div class="rounded-full border border-gray-200 bg-white px-3 py-2 shadow-lg">
          <div class="flex items-center gap-2 divide-x">
            <BreakpointIndicator />
            <ExportAuthLogsButton />
          </div>
        </div>
      </div>
    </Show>
  );
};

export default DevToolbar;
